import React from 'react'
import { reduxForm } from 'redux-form'

import { Collection, Group } from '../details/collection'
import { CollectionButton, Button } from '../buttons'
import IssueCardContainer from '../../containers/issues/issue-card-container'
import SingleAreaSelectContainer from '../../containers/forms/single-area-select-container'

class IssuesList extends React.Component {
  nextPageButton () {
    if (this.props.hasNextPage) {
      return <CollectionButton onClick={this.props.onLoadNextPage}>See more...</CollectionButton>
    }
  }

  issueList (collection) {
    return collection.map(issue =>
      <IssueCardContainer key={issue.id} issueId={issue.id} locationId={this.props.params.locationId}/>)
  }

  render () {
    const {
      allowFiltering,
      issuesForArea,
      filteredArea,
      viewAllIssuesClicked,
      needsWorkIssueCount,
      needsReviewIssueCount,
      permanentIssueCount,
      csvDownload
    } = this.props
    let filterField
    let viewAllIssuesButton
    let issueCounts

    // hasCounts will only ever be true when viewing issues for a location
    const countsList = [needsWorkIssueCount, needsReviewIssueCount, permanentIssueCount]
    const hasCounts = countsList.includes(!undefined)

    // If there is no filtered area, we want to show all issues.
    if (allowFiltering || !filteredArea && hasCounts) {

      filterField = (
        <div className='location-issues-filtering'>
          <SingleAreaSelectContainer
            locationId={this.props.params.locationId}
            {...this.props.fields.areaId}
            placeholder='Filter visible issues by area...'
          />
        </div>
      )

      issueCounts = (
        <div className='issue-counts-container'>
          <div className='issues'>
            <div className='large-pill'>
              <span className='badge needs-work'>{needsWorkIssueCount}</span>
              ATTENTION REQ.
            </div>
            <div className='large-pill'>
              <span className='badge needs-review'>{needsReviewIssueCount}</span>
              UNRESOLVED
            </div>
            <div className='large-pill'>
              <span className='badge'>{permanentIssueCount}</span>
              PERMANENT
            </div>
          </div>
        </div>
      )
    } else if (issuesForArea && filteredArea) {
      viewAllIssuesButton = <div className='location-issues-filtered'>
        <h1>{`Issues for ${filteredArea}`}</h1>
        <button
          className='button'
          onClick={viewAllIssuesClicked}>
          View All Issues
        </button>
      </div>
    }

    return (
      <div className='location-issues'>
        {filterField}
        {viewAllIssuesButton}
        {issueCounts}
        <Collection
          actionType='add'
          actionLink={`/location-issues/${this.props.params.locationId}/create`}
          secondaryActionType='download'
          secondaryActionCall={csvDownload}
        >
          <Group title='Attention Req.'>
            {this.issueList(this.props.needsWork)}
          </Group>
          <Group title='Unresolved'>
            {this.issueList(this.props.needsReview)}
          </Group>
          <Group title='Permanent'>
            {this.issueList(this.props.permanent)}
          </Group>
          <Group title='Resolved Archive'>
            {this.issueList(this.props.resolved)}
          </Group>
        </Collection>

        {this.nextPageButton()}
      </div>
    )
  }
}

export default reduxForm({
  form: 'locationIssuesAreaFilter',
  fields: ['areaId']
})(IssuesList)



// WEBPACK FOOTER //
// ./src/components/issues/issues-list.js